import Sentry from '../../Sentry';

const sentry = new Sentry();

export default sentry;
